const Talent = () => {
  return <div>Talent</div>;
};

export default Talent;
